_ = require 'underscore'
CustomFieldCardDetailBadgeView = require 'views/custom-field/custom-field-card-detail-badge-view'
t = require('views/internal/teacup-with-helpers')()
Util = require 'lib/util'

module.exports = class CustomFieldCheckboxCardDetailBadgeView extends CustomFieldCardDetailBadgeView
  template: t.renderable ({ icon, name, text, editable, color } = {}) ->
    t.h3 '.card-detail-item-header', { title: name }, ->
      t.icon icon
      t.text name

    t.span '.custom-field-detail-badge.custom-field-detail-checkbox-badge' + color,
      {
        class: t.classify({
          'js-custom-field-detail-badge': editable
          'is-clickable': editable
          'is-checked': @isChecked()
        })
      }
      , ->
        t.span '.custom-field-detail-badge-checkbox-box', ->
          t.span '.icon-sm.icon-check.custom-field-detail-badge-checkbox-icon'

  isChecked: ->
    @customFieldItem?.get('value')?.checked == 'true'

  getBadgeText: ->
    @customField.get('name')

  events:
    'click .js-custom-field-detail-badge': 'editCustomFieldBadge'

  editCustomFieldBadge: (e) ->
    Util.stop(e)
    @track()

    if !@customFieldItem?
      @model.customFieldItemList.create({
        idCustomField: @customField.id
        idModel: @model.id
        modelType: 'card'
        value:
          checked: 'true'
      })
      return

    newVal = !@customFieldItem.getParsedValue()
    if newVal
      @customFieldItem.setValue({ checked: newVal.toString() })
    else
      @customFieldItem.clearValue()



// WEBPACK FOOTER //
// ./app/scripts/views/custom-field/custom-field-checkbox-card-detail-badge-view.coffee